import { useState } from 'react';
import { AutoReorderSuggestions } from '@/components/inventory/AutoReorderSuggestions';
import { useToast } from '@/hooks/useToast';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function AutoReorderPage() {
  const navigate = useNavigate();
  const toast = useToast();

  const handleCreateRequisition = (items: any[]) => {
    toast.success('Requisitions created', `${items.length} items will be added to a new requisition.`);
    // In production, this would navigate to a pre-filled requisition form
    navigate('/requisitions');
  };

  return (
    <div className="space-y-6">
      <AutoReorderSuggestions onCreateRequisition={handleCreateRequisition} />
    </div>
  );
}
